import React  from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import TrainingClassModuleTable from "./components/TrainingClassModuleTable";


const ClassModules = () => {
	
	const { classeId } = useParams();

	return (
			<div>		    		
				<TrainingClassModuleTable classeId={classeId} />
			</div>
    );
};

const mapStateToProps = (state) => ({
  	  
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ClassModules);